import type { FaireProductEntity } from "../../entity_types/product";

export const p_wrzt25uww9: FaireProductEntity = {
  token: "p_wrzt25uww9",
  type: "product",
  name: "Organic Baby Blanket, Newborn Unisex Infant Organic Blankets",
  brandToken: "b_9fk13xj7jn",
  brandName: "MONAG",
  imageUrl:
    "https://cdn.faire.com/fastly/09fbe0cf7c5b449c466dbd3188af14201819bb26a942232b17ebf09c5d034cd4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/42afa06a1c3d295dbec1d26c830aea49640f8d0cfe699438e6bc34ed09eb094a.jpeg",
    "https://cdn.faire.com/fastly/9328067248d6d0a501ef2a9092ec039bb5b187f5e3459d066535d5c66757d6dd.jpeg",
    "https://cdn.faire.com/fastly/685491b4bec26de5547cc54f88ec076c90e9dbd8f7bbd415d397c424779eacd5.jpeg",
    "https://cdn.faire.com/fastly/70828daeaafbf52cdfe0659f1f8436f1450b9a9e54c89906d21b43a670dbc6a0.jpeg",
    "https://cdn.faire.com/fastly/2c2f58d57a700a3bad3fe3911af856039d5ee351b6f44c75f35248e818460e69.jpeg",
  ],
  priceDollars: 15.95,
  description:
    '  Made from 100% organic cotton , it is free from harmful chemicals, dyes, and synthetic materials, ensuring a safe and gentle touch. The breathable fabric provides warmth and comfort while regulating temperature, making it perfect for all seasons.\nMATERIAL QUALITY: Soft, breathable organic cotton baby Blankets. Checkout matching onesies and beanies\n     DESIGN FEATURES: Binding all around for longer lasting and keeps it shape.  Approx. 36" x 30"\n    VERSATILE WEAR: Perfect for everyday use, layering, or special occasions with classic solid color styling.   Perfect Earth Tone Colors\n    EASY CARE: Machine washable garments maintain their shape and color through multiple washes',
  tags: [],
  msrpDollars: 31.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:04.387Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
